var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_download",
    "data-name": "icon download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_download-2",
    "data-name": "icon download",
    d: "M9.493,7.332a.506.506,0,1,1,.681.748L7.5,10.515,4.824,8.08A.506.506,0,0,1,5.5,7.332L6.993,8.687V2.506A.506.506,0,0,1,8,2.506V8.687ZM3,10.5a.5.5,0,0,0-1,0v.667A1.833,1.833,0,0,0,3.833,13h7.333A1.833,1.833,0,0,0,13,11.166V10.5a.5.5,0,0,0-1,0v.667a.833.833,0,0,1-.833.833H3.833A.833.833,0,0,1,3,11.166Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b8c8e3523fa1cae8c7cd736e08bece5d.svg";
export { ForwardRef as ReactComponent };